import React from "react";
import moment from "moment"
const ProfileStatus = (props) => {
  const { status = '', expireDate, memberStatus, dayExpire, memberPayment } = props
  const startDate = memberPayment?.startDate ?? null
  const endDate = memberPayment?.endDate ?? null
  // const startDate =  null
  // const endDate = null
  console.log('props >>', props)
  // this.props?.user?.lineId?.memberId
  if (!memberStatus || memberStatus == 1) {
    return (
      <div className={`profile-status wait`}>
          <div className="icon">
            <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.5 0C4.25328 0 0 4.25328 0 9.5C0 14.7467 4.25328 19 9.5 19C14.7467 19 19 14.7467 19 9.5C19 4.25328 14.7467 0 9.5 0ZM12.5645 9.5C12.5645 11.1898 11.1898 12.5645 9.5 12.5645C7.81023 12.5645 6.43548 11.1898 6.43548 9.5C6.43548 7.81023 7.81023 6.43548 9.5 6.43548C11.1898 6.43548 12.5645 7.81023 12.5645 9.5Z" fill="#FAC818"/>
            </svg>
          </div>
          <div className="info">รออนุมัติการเป็นสมาชิก</div>
      </div>
    );
  }
  else if (status === 'Success' && memberStatus == 2 && ( startDate === null || endDate === null )) {
    return (
      <div className={`profile-status ${status.toLowerCase()}`}>
          <div className="icon">
            <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 9.5C19 14.7467 14.7467 19 9.5 19C4.25328 19 0 14.7467 0 9.5C0 4.25328 4.25328 0 9.5 0C14.7467 0 19 4.25328 19 9.5ZM8.40114 14.5302L15.4495 7.48179C15.6889 7.24245 15.6889 6.85436 15.4495 6.61503L14.5828 5.74827C14.3434 5.50889 13.9553 5.50889 13.716 5.74827L7.96774 11.4965L5.28403 8.81274C5.04469 8.57341 4.65661 8.57341 4.41723 8.81274L3.55047 9.6795C3.31113 9.91884 3.31113 10.3069 3.55047 10.5463L7.53434 14.5301C7.77372 14.7695 8.16176 14.7695 8.40114 14.5302Z" fill="#8ED16F"/>
            </svg>
          </div>
          <div className="info">
            อนุมัติการแจ้งชำระค่าสมาชิกแล้ว
          { expireDate && <div className="info-expire">วันหมดอายุ : { moment(expireDate).format('DD/MM/YYYY') }</div> }
          </div>
          
      </div>
    );
  }
  else if (status === 'Success' && memberStatus == 2 && dayExpire < 0) {
    return (
      <div className={`profile-status ${status.toLowerCase()}`}>
          <div className="icon">
          <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.5 0C4.25202 0 0 4.25202 0 9.5C0 14.748 4.25202 19 9.5 19C14.748 19 19 14.748 19 9.5C19 4.25202 14.748 0 9.5 0ZM14.1581 11.9938C14.3381 12.1738 14.3381 12.4649 14.1581 12.645L12.6411 14.1581C12.4611 14.3381 12.17 14.3381 11.9899 14.1581L9.5 11.6452L7.00625 14.1581C6.82621 14.3381 6.53508 14.3381 6.35504 14.1581L4.84194 12.6411C4.66189 12.4611 4.66189 12.17 4.84194 11.9899L7.35484 9.5L4.84194 7.00625C4.66189 6.82621 4.66189 6.53508 4.84194 6.35504L6.35887 4.83811C6.53891 4.65806 6.83004 4.65806 7.01008 4.83811L9.5 7.35484L11.9938 4.84194C12.1738 4.66189 12.4649 4.66189 12.645 4.84194L14.1619 6.35887C14.3419 6.53891 14.3419 6.83004 14.1619 7.01008L11.6452 9.5L14.1581 11.9938Z" fill="#DC2626"/>
          </svg>
          </div>
          <div className="info">
            ยังไม่ชำระค่าสมาชิก
          { expireDate && <div className="info-expire">วันหมดอายุ : { moment(expireDate).format('DD/MM/YYYY') }</div> }
          </div>
          
      </div>
    );
  }
  else if (status === 'Success' && memberStatus == 2) {
    return (
      <div className={`profile-status ${status.toLowerCase()}`}>
          <div className="icon">
            <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 9.5C19 14.7467 14.7467 19 9.5 19C4.25328 19 0 14.7467 0 9.5C0 4.25328 4.25328 0 9.5 0C14.7467 0 19 4.25328 19 9.5ZM8.40114 14.5302L15.4495 7.48179C15.6889 7.24245 15.6889 6.85436 15.4495 6.61503L14.5828 5.74827C14.3434 5.50889 13.9553 5.50889 13.716 5.74827L7.96774 11.4965L5.28403 8.81274C5.04469 8.57341 4.65661 8.57341 4.41723 8.81274L3.55047 9.6795C3.31113 9.91884 3.31113 10.3069 3.55047 10.5463L7.53434 14.5301C7.77372 14.7695 8.16176 14.7695 8.40114 14.5302Z" fill="#8ED16F"/>
            </svg>
          </div>
          <div className="info">
            อนุมัติการแจ้งชำระค่าสมาชิกแล้ว
          { expireDate && <div className="info-expire">วันหมดอายุ : { moment(expireDate).format('DD/MM/YYYY') }</div> }
          </div>
          
      </div>
    );
  }
  else if (status === 'Wait') {
    return (
      <div className={`profile-status ${status.toLowerCase()}`}>
          <div className="icon">
            <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.5 0C4.25328 0 0 4.25328 0 9.5C0 14.7467 4.25328 19 9.5 19C14.7467 19 19 14.7467 19 9.5C19 4.25328 14.7467 0 9.5 0ZM12.5645 9.5C12.5645 11.1898 11.1898 12.5645 9.5 12.5645C7.81023 12.5645 6.43548 11.1898 6.43548 9.5C6.43548 7.81023 7.81023 6.43548 9.5 6.43548C11.1898 6.43548 12.5645 7.81023 12.5645 9.5Z" fill="#FAC818"/>
            </svg>
          </div>
          <div className="info">
            รออนุมัติการแจ้งชำระค่าสมาชิก
          { expireDate && <div className="info-expire">วันหมดอายุ : { moment(expireDate).format('DD/MM/YYYY') }</div> }
          </div>
      </div>
    );
  }
  return (
    <div className="profile-status">
        <div className="icon">
          <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.5 0C4.25202 0 0 4.25202 0 9.5C0 14.748 4.25202 19 9.5 19C14.748 19 19 14.748 19 9.5C19 4.25202 14.748 0 9.5 0ZM14.1581 11.9938C14.3381 12.1738 14.3381 12.4649 14.1581 12.645L12.6411 14.1581C12.4611 14.3381 12.17 14.3381 11.9899 14.1581L9.5 11.6452L7.00625 14.1581C6.82621 14.3381 6.53508 14.3381 6.35504 14.1581L4.84194 12.6411C4.66189 12.4611 4.66189 12.17 4.84194 11.9899L7.35484 9.5L4.84194 7.00625C4.66189 6.82621 4.66189 6.53508 4.84194 6.35504L6.35887 4.83811C6.53891 4.65806 6.83004 4.65806 7.01008 4.83811L9.5 7.35484L11.9938 4.84194C12.1738 4.66189 12.4649 4.66189 12.645 4.84194L14.1619 6.35887C14.3419 6.53891 14.3419 6.83004 14.1619 7.01008L11.6452 9.5L14.1581 11.9938Z" fill="#DC2626"/>
          </svg>
        </div>
        <div className="info">ยังไม่แจ้งชำระค่าสมาชิก</div>
    </div>
  );
};
export default ProfileStatus;
